<!-- 变更信息详情 -->
<template>
  <div class="diLink">
    <div class="top">
      <h2>变更信息详情</h2>
      <div class="info"></div>
      <div class="top-footer">
        <div class="item"><span>变更申请号</span><span>{{detail.authApplyNoStr}}</span></div>
        <div class="item"><span>变更申请时间</span><span></span></div>
        <div class="item"><span>变更申请状态</span><span>{{detail.workflowStatus}}</span></div>
      </div>
    </div>
    <div class="main">
      <div class="m-title">变更内容</div>
      <div class="main-content">
        <table class="tb">
          <tr>
            <td></td>
            <td class="before bold">变更前信息</td>
            <td class="after bold">变更后信息</td>
          </tr>
          <tr>
            <td>公司名称</td>
            <td>{{detail.origin.companyInfo.companyName}}</td>
            <td>{{detail.changeto.companyInfo.companyName}}</td>
          </tr>
          <tr>
            <td>行业类别</td>
            <td>{{detail.origin.companyInfo.industryType}}</td>
            <td>{{detail.changeto.companyInfo.industryType}}</td>
          </tr>
          <tr>
            <td>企业规模</td>
            <td>{{detail.origin.companyInfo.scale}}</td>
            <td>{{detail.changeto.companyInfo.scale}}</td>
          </tr>
          <tr>
            <td>姓名</td>
            <td>{{detail.origin.userInfo.userName}}</td>
            <td>{{detail.changeto.userInfo.userName}}</td>
          </tr>
          <tr>
            <td>证件类型</td>
            <td>{{detail.origin.userInfo.certType}}</td>
            <td>{{detail.changeto.userInfo.certType}}</td>
          </tr>
          <tr>
            <td>证件号码</td>
            <td>{{detail.origin.userInfo.certNo}}</td>
            <td>{{detail.changeto.userInfo.certNo}}</td>
          </tr>
          <tr>
            <td>变更原因</td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div class="m-title mgtb30">所需文件</div>
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="file"
            label="所需文件"
            width="180">
          </el-table-column>
          <el-table-column
            prop="img"
            label="缩略图"
            width="180">
            <template slot-scope="scope">
              <img :src="tableData[scope.$index].img" alt="">
            </template>
          </el-table-column>
          <el-table-column
            prop="note"
            label="示例/模板">
          </el-table-column>
          <el-table-column
            prop="operate"
            label="操作">
            <template slot-scope="scope">
              <a :href="tableData[scope.$index].img" download="img">下载</a>
              <el-button
                @click.native.prevent="deleteRow(scope.$index, tableData)"
                type="text"
                size="small">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
    </div>

    <div class="footer">
      <el-button type="primary" @click="back">返回</el-button>
    </div>
  </div>
</template>

<script>
import img from '@/assets/img/logo.png'
    export default {
    name: 'infoChangeDetail',
    components: {    },
    data() {
      return {
        tableData:[
          {
            file:'营业执照复印件',
            img:img,
            note:'233'
          },
          {
            file:'管理员身份证复印件（正反合成一张图）',
            img:img,
            note:'233'
          },
          {
            file:'委托授权书',
            img:img,
            note:'233'
          },
          {
            file:'法定代表人身份证复印件',
            img:img,
            note:'233'
          }
        ],

      }
    },
    props:{
      detail:{
        type:Object
      }
    },
    mounted() {
    },
    methods: {
    // format(row,col,cellvalue,index){
    //   return cellvalue.split('')[0]
    // },
     back(){
       this.$emit('showList')
     }
    },
    created(){
      console.log('detail',this.detail)
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
  .top{
    background: #fff;
    h2{
      font-size: 18px ;
      font-weight: bold;
    }
    .info{
      font-size: 12px;
      color: #666;
      padding: 10px 0 ;
    }
    .top-footer{
      display: flex;
      padding-left: 30px;
      .item{
        font-size: 14px;
        margin-right: 10%;
        span:last-child{
          padding-left: 20px;
        }
      }
    }
  }
  .m-title{
    color: rgb(27, 91, 191);
    position: relative;
    line-height: 1;
    padding-left: 10px;
    font-weight: bold;
    &::before{
      content: '';
      position: absolute;
      left: 0;
      height: 100%;
      width: 5px;
      background:rgb(27, 91, 191);
      transform: skewY(20deg);
    }
  }
  .main{
    margin-top: 30px;
  }
  .main-content{
    display: flex;
  }
  .tb{
    .bold{font-weight: bold;}
    td{
      padding: 10px 0;
    }
    tr td:first-child{
      padding-left: 50px;
      padding-right: 30px;
      text-align: right;
      color: #666;
    }
    .before{
      min-width: 350px;
    }
  }
  .mgtb30{
    margin:  30px 0;
  }
  .footer{
    margin-top: 30px;
    text-align: center;
  }
</style>

